<script lang="ts">
	import { onMount } from "svelte";

	let options = {
		root: null,
		rootMargin: "0px",
		threshold: 0.5
	};

	let callback = (entries: IntersectionObserverEntry[]) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add("animate");
				setTimeout(() => {
					entry.target.classList.remove("animate_idle");
				}, 2000);
			}
		});
	};

	const classes = [
		".animate-fade",
		".animate-splash",
		".animate-grow",
		".animate-from-top",
		".animate-from-top-left",
		".animate-from-top-right",
		".animate-from-right",
		".animate-from-left",
		".animate-from-bottom-left",
		".animate-from-bottom-right",
		".animate-from-bottom",
		".animate-underline",
		".animate-height"
	];

	onMount(() => {
		let observer = new IntersectionObserver(callback, options);

		const matches = document.querySelectorAll(classes.join(","));

		Array.from(matches).forEach((el) => {
			el.classList.add("animate_idle");
			observer.observe(el);
		});
	});
</script>
